// extracted by mini-css-extract-plugin
module.exports = {"average-star":"_1azcI6","average":"_2d4LTz","star":"_2yxeXv","ratings":"_2afbiS"};